import throttle from 'lodash/throttle';

export default class {
  constructor({ player, percentInView, playWhenOnTop, dontPlay }) {
    this.player = player;
    this.playWhenOnTop = playWhenOnTop;
    this.wrapper = this.player.getContainer();
    this.throttledScrollListener = throttle(() => {
      this.playerInView(percentInView, dontPlay);
    }, 300);
  }

  // throttledScrollListener() {
  //   return throttle(() => {
  //     console.log('gsdgdg')
  //     this.playerInView(percentInView);
  //   }, 300);
  // }

  playerPosition(playerEl) {
    if (playerEl && playerEl.getBoundingClientRect) {
      const bodyRect = document.body.getBoundingClientRect();
      const playerRect = playerEl.getBoundingClientRect();
      return playerRect.top - bodyRect.top - this.scrollPosition().top;
    }
    return null;
  }

  scrollPosition() {
    const doc = document.documentElement;
    return {
      left: (window.pageXOffset || doc.scrollLeft) - (doc.clientLeft || 0),
      top: (window.pageYOffset || doc.scrollTop) - (doc.clientTop || 0)
    };
  }

  playerInView(percentInView, dontPlay) {
    if (dontPlay) {
      return this.player.stop();
    }
    const pixelsInView = this.player.getHeight() * percentInView / 100;
    const difference = this.playerPosition(this.wrapper) + pixelsInView;
    const adjust = window.innerHeight > pixelsInView ? window.innerHeight : 100;
    const inView = this.playWhenOnTop
      ? difference > pixelsInView &&
        difference < adjust &&
        this.scrollPosition().top >= 700
      : difference > pixelsInView && difference < adjust;

    return this.player.play(inView);
  }

  on() {
    window.addEventListener('scroll', this.throttledScrollListener);
  }

  off() {
    window.removeEventListener('scroll', this.throttledScrollListener);
  }
}



// WEBPACK FOOTER //
// ./src/views/components/video_module/utils/video_module_autoplay.js